import styles from "../../styles/portfolioManagerDashboard.module.scss"

function CardWrapper({children, classNames=""}) {
  return (
    <div 
      className={`${styles.cardWrapper} ${classNames}`}
    >
     {children}
    </div>
  );
}

export default CardWrapper
